<template>
  <a
    class="al-btn al-btn--primary ml-auto text-xs font-bold px-5 h-[27px] mr-5 whitespace-no-wrap rounded"
    href="/pricing/"
    @click.prevent="clickOnFree('Start Free Now')"
  >
    Start Free Now
  </a>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';

export default {
  methods: {
    clickOnFree(buttonName) {
      eventTracker(analyticsEvents.clickStartFreeTrial, {
        source: 'header',
        button_name: buttonName,
      });
      this.$store.dispatch('setOpenSignUpModal', { open: true, clickSource: 'main navigation', buttonName });
    },
  },
};
</script>

<style scoped>
.h-\[27px\] {
  height: 27px;
}
</style>